/*
const { userAgent } = typeof window === 'undefined' ? {} : window.navigator;
let OS;

if (userAgent.match(/Android/i)) {
  OS = 'android';
} else if (userAgent.match(/iP(ad|hone|od)/i)) {
  OS = 'ios';
} else if (userAgent.match(/Mac(intosh| OS X)/i)) {
  OS = 'macos';
} else if (userAgent.match(/Windows/i)) {
  OS = 'windows';
}
*/

// Inspired from: https://github.com/necolas/react-native-web/blob/master/packages/react-native-web/src/exports/Platform/index.js
/**
 * Provides a minimal equivalent of react-native's Platform abstraction.
 */
const platform = {
  /**
   * The operating system on which the application is executing.
   *
   * @type {string}
   */
  OS: 'web',

  select: (obj: any) => ('web' in obj ? obj.web : obj.default),

  /**
   * The operating system version on which the application is executing.
   * This is intentionally set to undefined so we can tell mobile and mobile web
   * appart easier.
   *
   * @type {number|undefined}
   */
  Version: undefined,
};

export default platform;
